function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

export var getOptionPropsHelper = _ref => {
  var {
    getItemProps,
    highlightedIndex,
    getTestId
  } = _ref;
  return _ref2 => {
    var {
      option,
      index,
      isCreatableOption
    } = _ref2;
    return _objectSpread(_objectSpread({}, getItemProps({
      item: option,
      index
    })), {}, {
      isHighlighted: highlightedIndex === index,
      key: "".concat(option.label, "-").concat(index)
    }, !isCreatableOption && {
      'data-testid': option.testId || getTestId("option-".concat(index))['data-testid']
    });
  };
};
//# sourceMappingURL=utils.js.map